"use strict";
exports.__esModule = true;
exports.counties = void 0;
var counties = [
    { id: 1, name: 'Adams' },
    { id: 2, name: 'Asotin' },
    { id: 3, name: 'Benton' },
    { id: 4, name: 'Chelan' },
    { id: 5, name: 'Clallam' },
    { id: 6, name: 'Clark' },
    { id: 7, name: 'Columbia' },
    { id: 8, name: 'Cowlitz' },
    { id: 9, name: 'Douglas' },
    { id: 10, name: 'Ferry' },
    { id: 11, name: 'Franklin' },
    { id: 12, name: 'Garfield' },
    { id: 13, name: 'Grant' },
    { id: 14, name: 'Grays Harbor' },
    { id: 15, name: 'Island' },
    { id: 16, name: 'Jefferson' },
    { id: 17, name: 'King' },
    { id: 18, name: 'Kitsap' },
    { id: 19, name: 'Kittitas' },
    { id: 20, name: 'Klickitat' },
    { id: 21, name: 'Lewis' },
    { id: 22, name: 'Lincoln' },
    { id: 23, name: 'Mason' },
    { id: 24, name: 'Okanogan' },
    { id: 25, name: 'Pacific' },
    { id: 26, name: 'Pend Oreille' },
    { id: 27, name: 'Pierce' },
    { id: 28, name: 'San Juan' },
    { id: 29, name: 'Skagit' },
    { id: 30, name: 'Skamania' },
    { id: 31, name: 'Snohomish' },
    { id: 32, name: 'Spokane' },
    { id: 33, name: 'Stevens' },
    { id: 34, name: 'Thurston' },
    { id: 35, name: 'Wahkiakum' },
    { id: 36, name: 'Walla Walla' },
    { id: 37, name: 'Whatcom' },
    { id: 38, name: 'Whitman' },
    { id: 39, name: 'Yakima' },
];
exports.counties = counties;
//# sourceMappingURL=counties.js.map